import { render, staticRenderFns } from "./eventList.vue?vue&type=template&id=2cde83b2&scoped=true"
import script from "./eventList.vue?vue&type=script&lang=ts"
export * from "./eventList.vue?vue&type=script&lang=ts"
import style0 from "./eventList.vue?vue&type=style&index=0&id=2cde83b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cde83b2",
  null
  
)

export default component.exports